import React from 'react';

const htmlizeCarriageReturn = text => {
  if (!text) return '';
  const arrayText = text.split(/\n/);
  return (
    <>
      {arrayText.map((line, i) => {
        return (
          <React.Fragment key={i}>
            {i > 0 && <br />}
            {line}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default htmlizeCarriageReturn;
